import {PREFS_UNITS_TYPE} from '../components/globalPrefs/GlobalPrefsDialog'
import PrefsService from "./PrefsService"
import NCSThemes from "../style/NCSThemes"

export default new class GlobalPrefsService {
    getPrefs () {
        let globalPrefs = PrefsService.get('globalPrefs')
        if (globalPrefs) {
            globalPrefs = JSON.parse(globalPrefs)
        }
        return Object.assign({}, globalPrefs || {})
    }
    getColorTheme () {
        let globalPrefs = this.getPrefs()
        return this.resolveColorTheme(globalPrefs.colorTheme)
    }
    // Validates a color theme name, falling back to 'NCSLight' when it is not
    // a known theme. Shared by getColorTheme() and callers that already have a
    // (possibly unsaved) theme value, e.g. the prefs dialog preview.
    resolveColorTheme (colorTheme) {
        if (Object.hasOwn(NCSThemes, colorTheme))
        {
            return colorTheme
        }
        return 'NCSLight'
    }
    getEnableGraphLineMarkers () {
        let globalPrefs = this.getPrefs()
        // undefined value means to show the graph line markers when space allows
        return globalPrefs.enableGraphLineMarkers === false ? false : undefined
    }
    getEnableMapBillboardsToDots () {
        let globalPrefs = this.getPrefs()
        return globalPrefs.enableMapBillboardsToDots === false ? false : true
    }

    getClearMapCacheOnExit () {
        let globalPrefs = this.getPrefs()
        return globalPrefs.clearMapCacheOnExit === false ? false : true
    }

    getMapExportIncludeLabels () {
        let globalPrefs = this.getPrefs()
        return globalPrefs.mapExportIncludeLabels === false ? false : true
    }

    getIdName () {
        let globalPrefs = this.getPrefs()
        return globalPrefs.idName || 'both'
    }
    getAllColors () {
        let colors = NCSThemes[this.getColorTheme()].colors
        return colors
    }
    // Extracts series-1 through series-11 into a flat array — the format
    // Highcharts' `colors` option expects for automatic series coloring.
    getSeriesPalette () {
        const colors = this.getAllColors() || {}
        const palette = []
        for (let i = 1; i <= 11; i++)
        {
            const color = colors[`series-${i}`]
            if (color)
            {
                palette.push(color)
            }
        }
        return palette
    }
    getSeverityColor (severity) {
        let alarmColors =  NCSThemes[this.getColorTheme()].colors
        switch(severity) {
            case 'SEV10':
                return alarmColors['alarm-critical']
            case 'SEV20':
                return alarmColors['alarm-major']
            case 'SEV30':
                return alarmColors['alarm-minor']
            case 'SEV40':
                return alarmColors['alarm-info']
            case 'SEV50':
                return alarmColors['alarm-unknown']
            default:
                return alarmColors['alarm-unknown']
        }
    }
    getDuration() {
        let globalPrefs = this.getPrefs();
        return globalPrefs.duration;
    }
    getSnackbarDisplayTimeout(){
        let globalPrefs = this.getPrefs();
        return globalPrefs.snackbarDisplayTimeout ?? 5000;
    }
    getUnitsType ()
    {
        let globalPrefs = this.getPrefs()
        return globalPrefs.unitsType === undefined ? PREFS_UNITS_TYPE.METRIC : globalPrefs.unitsType
    }
    getPageRefreshInterval()
    {
        let globalPrefs = this.getPrefs()
        return globalPrefs.pageRefreshInterval === undefined ? 0 : parseInt (globalPrefs.pageRefreshInterval)
    }
    getDefaultRadiosTable() {
        let globalPrefs = this.getPrefs()
        return globalPrefs.defaultRadiosTable || 'status'
    }
}
